/* eslint-disable eqeqeq */
import { API } from '@/api'
import tracerVuePlugin from '@mc/tracer-vue-plugin'
import { appKey } from '@/defines/environment'
class User {
  mallType = 0

  get isMemberMall() {
    return this.mallType == 2 || appKey == 'small'
  }

  async getcompany() {
    const res = await API.account.getCompany()
    this.mallType = res.mallType || 0
    this.mcGray = res.MC_GRAY || ''
    this.setMcGray(this.mcGray)
    tracerVuePlugin.updateParam({
      commonParams: {
        mall_type: String(this.mallType)
      }
    })
  }

  setMcGray = mcGray => {
    localStorage.setItem('mc_MC_GRAY', mcGray)
  }

  getMcGray = () => {
    const mcGray = this.mcGray
      ? this.mcGray
      : localStorage.getItem('mc_MC_GRAY')
    return mcGray || ''
  }
}

export const userInfo = new User()
